import React, { FC, useState } from 'react'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import Button from 'UI/Button/Button'
import { _source } from 'utils/csvConfig'
import { getUrlPageValues } from '../../containers/VerticalPage/common/utils'
import { onCSVExport } from 'utils/verticals'
import useMessage from '../../hooks/useCustomMessage'

const exportIconUrl = require('../../icons/export.svg')

interface IExportCSVTableVertical {
  zoneIndex: string
  csvFileName: string
  searchValue: string
  selectedIds?: string[]
  sorting?: {
    desc: boolean
    id: string
  }[]
}

const ExportCSVTableVertical: FC<IExportCSVTableVertical> = ({
  zoneIndex,
  csvFileName,
  searchValue,
  selectedIds,
  sorting,
}) => {
  const { trackEvent } = useMatomo()
  const { openMessage, contextHolder } = useMessage()

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const onExportClick = () => {
    setIsLoading(true)
    onCSVExport(zoneIndex, _source, getUrlPageValues()[0], csvFileName, searchValue, trackEvent, selectedIds, sorting)
      .then(() => openMessage('success', 'File successfully exported'))
      .catch(() => openMessage('error', 'File export failed , please try again later'))
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      {contextHolder}
      <Button
        loading={isLoading}
        buttonType='primary'
        icon={<img src={exportIconUrl} alt='Export' />}
        onClick={onExportClick}
      >
        Export
      </Button>
    </>
  )
}

export default ExportCSVTableVertical
